/**
 * Финансы опубликованной ревизии: недостача / излишек по diff_qty (ожид. − факт).
 * Розница: поле product_retail_price с бэка (= cost_price карточки товара).
 */

function round3(n) {
  return Math.round(Number(n) * 1000) / 1000;
}

export function parseRevisionQty(value) {
  if (value === null || typeof value === "undefined") return null;
  const v = typeof value === "string" ? value.trim() : value;
  if (v === "") return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  return n;
}

export function formatRevisionQty(value) {
  const n = parseRevisionQty(value);
  if (n === null) return "—";
  return n.toFixed(3).replace(/\.?0+$/, "");
}

export function moneyRu(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return "—";
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(x);
}

function roundMoney2(n) {
  return Math.round(Number(n) * 100) / 100;
}

/**
 * @returns {{ rows: object[], scope: 'full'|'list' }|null}
 */
export function getPostedRevisionFinanceRows(revision, items) {
  if (!revision || revision.status !== "posted") return null;
  const nested = Array.isArray(revision.items) ? revision.items : [];
  if (nested.length > 0) return { rows: nested, scope: "full" };
  return { rows: items || [], scope: "list" };
}

/**
 * diff_qty: expected minus counted. Positive = shortage, negative = surplus.
 */
export function computePostedRevisionFinance(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const shortage = [];
  const surplus = [];
  for (const it of list) {
    const d = parseRevisionQty(it.diff_qty);
    if (d === null || round3(d) === 0) continue;
    const unitCostRaw = parseRevisionQty(it.product_unit_self_cost);
    const unitWhRaw = parseRevisionQty(it.product_wholesale_price);
    const unitRetailRaw = parseRevisionQty(it.product_retail_price);
    const unitCost = unitCostRaw !== null ? unitCostRaw : 0;
    const unitWh = unitWhRaw !== null ? unitWhRaw : 0;
    const unitRetail = unitRetailRaw !== null ? unitRetailRaw : 0;
    const name = it.product_name || (it.product != null ? String(it.product) : "—");
    const barcode = it.product_barcode || "";
    const pushRow = (qty, bucket) => {
      const row = {
        key: it.id,
        product_name: name,
        barcode,
        qty,
        amount_cost: roundMoney2(qty * unitCost),
        amount_wholesale: roundMoney2(qty * unitWh),
        amount_retail: roundMoney2(qty * unitRetail),
        diff_wh_minus_cost: roundMoney2(qty * unitWh - qty * unitCost),
        diff_retail_minus_cost: roundMoney2(qty * unitRetail - qty * unitCost),
      };
      bucket.push(row);
    };
    if (d > 0) {
      pushRow(d, shortage);
    } else {
      pushRow(-d, surplus);
    }
  }
  const sum3 = (arr, k) => arr.reduce((a, x) => a + (Number(x[k]) || 0), 0);
  const tShort = {
    lines: shortage.length,
    qty: sum3(shortage, "qty"),
    cost: roundMoney2(sum3(shortage, "amount_cost")),
    wholesale: roundMoney2(sum3(shortage, "amount_wholesale")),
    retail: roundMoney2(sum3(shortage, "amount_retail")),
  };
  const tSur = {
    lines: surplus.length,
    qty: sum3(surplus, "qty"),
    cost: roundMoney2(sum3(surplus, "amount_cost")),
    wholesale: roundMoney2(sum3(surplus, "amount_wholesale")),
    retail: roundMoney2(sum3(surplus, "amount_retail")),
  };
  return {
    shortage,
    surplus,
    tShort,
    tSur,
    grandCost: roundMoney2(tShort.cost + tSur.cost),
    grandWholesale: roundMoney2(tShort.wholesale + tSur.wholesale),
    grandRetail: roundMoney2(tShort.retail + tSur.retail),
  };
}
